import modal from './Modal';

export default function addressModal() {
    type StateType = {
      id:string,
      name: string | number
    };

    return {
      countryCode: null,
      administrativeArea: null,
      stateSelectId: null,
      stateTextId: null,
      showStateSelect: false,
      states() {
        return window.stateList;
      },
      getStatesForCountryCode() {
        const allStates = this.states();
        if (this.countryCode !== null && allStates[this.countryCode]) {
          return allStates[this.countryCode];
        }

        return [];
      },
      stateSelected(state: StateType) {
        return state && state.id === this.administrativeArea;
      },
      onChange() {
        this.showStateSelect = Object.keys(this.getStatesForCountryCode()).length > 0;
      },
      ...modal(),
    };
}
